import { Directive } from '@angular/core';
import { BrnTooltipTrigger, provideBrnTooltipDefaultOptions } from '@spartan-ng/brain/tooltip';

export const DEFAULT_TOOLTIP_CONTENT_CLASSES =
  'bg-components-content-neutral-primary text-components-content-neutral-primary-reversed animate-in fade-in-0 zoom-in-95 z-50 w-fit rounded-md px-3 py-1.5 text-small-medium text-balance ' +
  'data-[state=open]:animate-in ' +
  'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 ' +
  'data-[side=below]:slide-in-from-top-2 data-[side=above]:slide-in-from-bottom-2 ' +
  'data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 ';

@Directive({
  selector: '[hlmTooltipTrigger]',
  providers: [
    provideBrnTooltipDefaultOptions({
      showDelay: 150,
      hideDelay: 300,
      exitAnimationDuration: 150,
      tooltipContentClasses: DEFAULT_TOOLTIP_CONTENT_CLASSES,
    }),
  ],
  hostDirectives: [
    {
      directive: BrnTooltipTrigger,
      inputs: [
        'brnTooltipDisabled: hlmTooltipDisabled',
        'brnTooltipTrigger: hlmTooltipTrigger',
        'aria-describedby',
        'position',
        'positionAtOrigin',
        'hideDelay',
        'showDelay',
        'exitAnimationDuration',
        'touchGestures',
      ],
    },
  ],
})
export class HlmTooltipTrigger {}
